(function () {
    'use strict';

    angular.module("imApp").factory("docPackTypeService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 3285,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3286,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
